/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Web_FormInputs */

const cs_enum_web_form = /** @type {(inputs: Enum_Web_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webový formulář`)
};

const en_enum_web_form = /** @type {(inputs: Enum_Web_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web form`)
};

/**
* | output |
* | --- |
* | "Web form" |
*
* @param {Enum_Web_FormInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_web_form = /** @type {((inputs?: Enum_Web_FormInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Web_FormInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_web_form(inputs)
	return cs_enum_web_form(inputs)
});